import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=14fac976&scoped=true"
import script from "./questionEdit.vue?vue&type=script&lang=js"
export * from "./questionEdit.vue?vue&type=script&lang=js"
import style0 from "./questionEdit.vue?vue&type=style&index=0&id=14fac976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fac976",
  null
  
)

export default component.exports